import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {TheBorder} from "../../TheBorder";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheBorderAvalancheFillUpReelsPresentation implements FlowStatePresentation {

    private _controller: FlowStateController;
    private _fillUpResponse: boolean = false;
    private _tl: gsap.core.Timeline;

    public start(controller: FlowStateController): void {
        this._controller = controller;
        this._fillUpResponse = true;
        this.checkToStartFillUp();
    }

    public checkToStartFillUp(): void {
        if (TheBorder.model.avalancheCollapseComplete && this._fillUpResponse) {
            TheBorder.model.avalancheCollapseComplete = false;
            this._fillUpResponse = false;
            const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => this.complete()}),
                reels: string[][] = TheBorder.model.reels,
                nearWinReels: boolean[] = TheBorder.model.nearWinReels;
            let stopTime: number = 0,
                nearWinDelayAdded: boolean = false;

            this._tl = tl;
            this._tl.add(() => this._controller.setSkipCallback(() => this.skip()), 0.1);

            for (let i: number = 0; i < TheBorder.allReelsView.mainReelModels.length; i++) {
                if (reels[i].length === TheBorder.allReelsView.getReelLength(i)) {
                    // #380, #389, #390
                    tl.add(TheBorder.allReelsView.mainReelModels[i].getFillUpReelAnimation(), stopTime);
                    continue;
                }

                // if the first reel to stop is a nearWin reel
                if (!nearWinDelayAdded && (i < reels.length) && (nearWinReels[i])) {
                    nearWinDelayAdded = true;
                    tl.add(() => {
                        TheBorder.reelHighlighter.highlightReel(i);
                    });

                    stopTime += 2.5;
                }

                tl.add(TheBorder.allReelsView.mainReelModels[i].getFillUpReelAnimation(), stopTime);

                if (((i + 1) < reels.length) && (nearWinReels[i + 1])) {
                    nearWinDelayAdded = true;
                    tl.add(() => {
                        TheBorder.reelHighlighter.highlightReel(i + 1);
                    });

                    stopTime += 2.5;
                }
            }
            if (tl.duration() == 0) {
                tl.add(gsap.to(this, {duration: 0.001}));
            }
        }
    }

    private skip(): void {
        if (this._tl) {
            this._tl.totalProgress(1);
        }
    }

    private complete(): void {
        TheBorder.reelHighlighter.stopHighlight();
        this._controller.finish();
    }
}